import type { EditProps } from "react-admin";
import { BooleanInput, DateTimeInput, Edit, SimpleForm, TextField, TextInput } from "react-admin";
import GroupedPermissionsInput from "@/components/GroupedPermissionsInput";

const TenantApiKeysEdit = (props: EditProps) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="keyPrefix" label="Key prefix" />
      <TextInput source="name" required fullWidth />
      <TextInput source="appType" label="App type" fullWidth />
      <GroupedPermissionsInput
        source="permissions"
        reference="tenant-api-keys/permissions/available"
      />
      <BooleanInput source="isActive" />
      <DateTimeInput source="expiresAt" fullWidth />
      <DateTimeInput source="lastUsedAt" disabled fullWidth />
    </SimpleForm>
  </Edit>
);

export default TenantApiKeysEdit;
